import { Navigate, useParams } from "react-router-dom";

/**
 * Legacy /join/:shop route — replaced by the standalone DiscountMiniApp
 * at /d/:shop. Kept as a permanent redirect so older QR codes and saved
 * bookmarks keep working without surfacing the old branding.
 */
export default function PublicJoin() {
    const { shop } = useParams();
    const slug = (shop || "humairi").toLowerCase();
    return <Navigate to={`/d/${slug}`} replace />;
}
